/* import __COLOCATED_TEMPLATE__ from './key-display.hbs'; */
/* RESPONSIBLE TEAM: team-messenger */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

interface Args {
  secret: string;
  keyName?: string;
}

export default class KeyDisplay extends Component<Args> {
  @service declare intercomEventService: $TSFixMe;

  get maskedSecret() {
    let { secret } = this.args;
    if (!secret) {
      return '';
    }

    let visibleChars = 3;
    let maxMaskedChars = 13;
    let secretLength = secret.length;

    if (secretLength <= visibleChars) {
      return secret;
    }

    let maskLength = Math.min(maxMaskedChars, secretLength - visibleChars);
    let mask = '•'.repeat(maskLength);
    let visiblePart = secret.slice(-visibleChars);

    return mask + visiblePart;
  }

  @action
  async onCopy() {
    await this.intercomEventService.trackAnalyticsEvent({
      action: 'copied',
      object: 'security_key',
      place: 'messenger_settings',
      section: 'security_settings',
      key_name: this.args.keyName || 'unknown',
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'MessengerSettings::Security::KeyDisplay': typeof KeyDisplay;
    'messenger-settings/security/key-display': typeof KeyDisplay;
  }
}
